// Create a new file: Toast.js
import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaExclamationCircle, FaExclamationTriangle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import '../../css/feedback.css';

const Toast = ({ type = 'info', title, message, duration = 5000, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    
    useEffect(() => {
        if (duration) {
            const timer = setTimeout(() => {
                setIsVisible(false);
                setTimeout(onClose, 300);
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [duration, onClose]);
    
    const config = {
        success: {
            icon: <FaCheckCircle className="toast-icon" style={{ color: '#10b981' }} />,
            className: 'toast-success',
        },
        error: {
            icon: <FaExclamationCircle className="toast-icon" style={{ color: '#ef4444' }} />,
            className: 'toast-error',
        },
        warning: {
            icon: <FaExclamationTriangle className="toast-icon" style={{ color: '#F59E0B' }} />,
            className: 'toast-warning',
        },
        info: {
            icon: <FaInfoCircle className="toast-icon" style={{ color: '#3b82f6' }} />,
            className: 'toast-info',
        },
    }[type];
    
    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 300);
    };
    
    return (
        <div className={`whe2-toast ${config.className} ${isVisible ? '' : 'hide'}`}>
            <div className="toast-header">
                <div className="toast-title">
                    {config.icon}
                    <span>{title}</span>
                </div>
                <button className="toast-close" onClick={handleClose}>
                    <FaTimes />
                </button>
            </div>
            <p className="toast-message">{message}</p>
        </div>
    );
};

export default Toast;